module.exports = __webpack_public_path__ + "static/img/juhuaR32.6537d34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/juhua/juhuaR32.jpg
// module id = L3F4
// module chunks = 1